export class ShiftTeamStats {
    day_visitation = 0;
    day_drive = 0;
    evening_visitation = 0;
    evening_drive = 0;
}
